import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Headers from "./pages/publicPages/Header.jsx";
// import Home from "./pages/publicPages/Home.jsx";
// import Footer from "./pages/publicPages/Footer.jsx";
import Admin from "./pages/builderPages/Admin.jsx";
import SignUpPage from "./pages/authPages/SignUpPage.jsx";
import LoginPage from "./pages/authPages/LoginPage.jsx";

import TemplateSelection from "./pages/authPages/TemplateSelect.jsx";
import AddLinks from "./pages/authPages/LinksAdd.jsx";
import SuccessPage from "./pages/authPages/SuccessPage.jsx";
import AddProfileDetails from "./pages/authPages/ProfileDetails.jsx";
import LandingPage from "./pages/LandingPages/Index.jsx";

const App = () => {
  // Initialize isDarkMode with the value from local storage or default to false
  const [isDarkMode, setIsDarkMode] = useState(
    localStorage.getItem("isDarkMode") === "true" || false
  );
  const [userData, setUserData] = useState()

  // Function to toggle dark mode
  const toggleDarkMode = () => {
    setIsDarkMode((prev) => {
      const newState = !prev;
      // Save the new state to local storage
      localStorage.setItem("isDarkMode", newState);
      return newState;
    });
  };

  // Use effect to listen for changes in isDarkMode and save it to local storage
  useEffect(() => {
    localStorage.setItem("isDarkMode", isDarkMode);
  }, [isDarkMode]);

  return (
    <Router>
      <Routes>
        <Route path="/signup" element={<SignUpPage userData={userData} setUserData={setUserData} />} />
        <Route path="/admin" element={<Admin isDarkMode={isDarkMode} />} />
        <Route path="/" element={<LandingPage />} />
        {/* <Route path="/" element={<Home isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />} /> */}

        <Route path="/login" element={<LoginPage />} />
        {/* <Route path="/side" element={<Sidebar />} /> */}
        <Route path="/theme" element={<TemplateSelection />} />
        <Route path="/links" element={<AddLinks />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/profileDetails" element={<AddProfileDetails />} />



        {/* <Route
          path="/password-setup"
          element={
            <PasswordSetupPage userData={userData} setUserData={setUserData} />
          }
        /> */}
      </Routes>{" "}
    </Router>
  );
};

export default App;


// templates -> links 